<template>
  <v-btn
    v-if="create"
    :small="small"
    v-bind="buttonProperties"
    :color="color"
    :to="route"
    :href="href"
    :target="linkTarget"
    class="mx-2"
    @click.native="onClick"
  >
    <v-icon v-if="icon" left>{{icon}}</v-icon>
    <span>{{ label|t }}</span>
  </v-btn>
</template>

<script lang="babel" type="text/babel">
import formMetaAction from '@/components/form/formMetaAction/formMetaAction'
export default {
  mixins: [formMetaAction],
}
</script>

<style lang="sass" type="text/sass" scoped></style>
